import CardDetailTracking from 'components/molecules/Card/Detail/Tracking';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as dashboardAC, getMeasurement } from 'store/dashboard';
import { actionCreators as profileAC } from 'store/profile';
import { getInfoText, getTitle } from 'store/programItems';
import { actionCreators as trackingAC } from 'store/trackingDescription';

const mapStateToProps = (state: any, ownProps: any) => ({
	title: getTitle(state, ownProps.id),
	infoText: getInfoText(state, ownProps.id),
	measurement: {},
	profileMeasurement: getMeasurement(state),
	isUpdatingTracking: false,
	isCheckable: true,
	isDone: false,
	inputWeight: {
		input: {
			type: 'text',
			name: 'body-weight',
			id: 'body-weight',
			maxLength: 256,
		},
	},
	inputWaist: {
		input: {
			type: 'text',
			name: 'body-circumference',
			id: 'body-circumference',
			maxlength: 256,
		},
	},
	inputBodyFat: {
		input: {
			type: 'text',
			name: 'body-fat',
			id: 'body-fat',
			maxlength: 256,
		},
	},
	onComplete({ onAnimationDone }) {
		onAnimationDone();
		ownProps.parentProps.onBackFromDetail();
	},
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doSaveTracking: dashboardAC.doSaveMeasurement,
			doLoadUserData: profileAC.doLoadUserData,
			doOpenDescription: trackingAC.doOpenDescription,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardDetailTracking as any);
